module.exports = __webpack_public_path__ + "img/xiao02.c4a68a12.png";